import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../admin/Constant'


export const LoginApi = createApi({
    reducerPath: 'LoginApi',
    baseQuery: fetchBaseQuery({baseUrl: API_URL}),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
             url: `auth/login`,
             method: "POST",
             body: data
            })
         }),
        changePassword: builder.mutation({
            query: (data) => ({
             url: `auth/change-password`,
             method: "POST",
             body: data
            })
         }),
         }),
})

export const {useLoginMutation, useChangePasswordMutation} = LoginApi